export const NATIVE_PURCHASE_PATH = "/prototype/mobile/sliding/settings";
export const SLIDING_MASTER_PRODUCT_SKU = "com.pzl.sliding.quest.masterpass";
